export default __webpack_public_path__ + "d95836ecb1f92439a33f7c16bbde4a49.svg";